import * as React from 'react';
import { useRouter } from 'next/router';
// A11y
// import Icon from "components/icon/icon";
import { ButtonGroup } from 'components/badoo/button-group';
import Button from 'components/badoo/button/button';
import { common } from 'components/badoo/lexemes';
import Link from 'next/link';
import { Route } from 'lib/app/route';
import { useAmp } from 'next/amp';

type Props = {
    onSignInClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
    onSignUpClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
};

const PageHeader: React.FunctionComponent<Props> = ({ onSignInClick, onSignUpClick }) => {
    const isAmp = useAmp();
    const router = useRouter();
    const isMainPage = router.asPath === '/';
    const indexPageRoute = isMainPage ? Route.INDEX : Route.INS_AND_OUTS_BLOG;

    return (
        <header className="page-header">
            <div className="page-header__inner">
                <Link href={indexPageRoute} legacyBehavior={true}>
                    <a
                        className="page-header__logo"
                        href={isAmp ? Route.INS_AND_OUTS_BLOG : indexPageRoute}
                        aria-label="Badoo Home Page"
                    >
                        <span
                            className="icon icon--size-stretch"
                            data-qa="icon"
                            data-qa-icon-name="logo-big"
                            role="img"
                        >
                            <svg
                                fill="none"
                                height="34"
                                viewBox="0 0 148 34"
                                width="148"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                            >
                                <path
                                    d="m131.295 25.2789c-4.715 0-8.024-3.445-8.024-8.295 0-4.8501 3.309-8.29507 8.024-8.29507 4.714 0 8.023 3.44497 8.023 8.29507 0 4.85-3.309 8.295-8.023 8.295zm-32.4553 0c-4.7141 0-8.0231-3.445-8.0231-8.295 0-4.8501 3.309-8.29507 8.0231-8.29507 4.7143 0 8.0233 3.44497 8.0233 8.29507 0 4.85-3.309 8.295-8.0233 8.295zm-34.4493-.0454c-.2719 0-.4533-.1813-.4533-.4532v-15.59286c0-.27197.1814-.45328.4533-.45328h1.9945c4.7141 0 8.023 3.39964 8.023 8.24974 0 4.85-3.3089 8.2496-8.023 8.2496zm-24.6584 1.0426c-2.8103 0-4.2608-1.0879-4.2608-3.2636 0-1.7225 1.6318-2.9463 3.9888-2.9463h5.802c.272 0 .4533.1813.4533.4532v1.5865c0 2.0398-3.3543 4.1702-5.9833 4.1702zm-30.82305-12.3746c-.27197 0-.45328-.1813-.45328-.4532v-4.26086c0-.27197.18131-.45328.45328-.45328h5.57535c2.0851 0 3.3089.95188 3.3089 2.58374 0 1.6318-1.2238 2.5836-3.3089 2.5836zm0 11.332c-.27197 0-.45328-.1813-.45328-.4532v-4.2609c0-.2719.18131-.4532.45328-.4532h6.66325c2.0851 0 3.3089.9518 3.3089 2.5837 0 1.6318-1.2238 2.5836-3.3089 2.5836zm89.93075 8.0684c7.0713 0 12.9643-3.8528 15.2753-10.1534.182-.4533.544-.68.952-.68s.771.2267.952.68c2.312 6.3006 8.204 10.1534 15.276 10.1534 9.382 0 16.408-6.8898 16.408-16.318 0-9.42827-7.026-16.318129-16.408-16.318129-7.072 0-12.964 3.852879-15.276 10.153429-.181.4533-.544.68-.952.68s-.77-.2267-.952-.68c-2.311-6.30055-8.204-10.153429-15.2753-10.153429-7.0712 0-12.9638 3.852879-15.2755 10.153429-.1813.4533-.544.68-.9519.68-.408 0-.7706-.2267-.9519-.68-2.2664-5.98325-8.1137-9.70015-15.2755-9.70015h-9.7002c-.4986 0-.9066.40795-.9066.90656v19.94429c0 .544-.408.9066-.9519.9066s-.9519-.3626-.9519-.9066v-8.6576c0-8.24971-4.4874-12.646529-12.9185-12.646529-8.431 0-12.7371 3.852879-12.9638 9.700229 0 .5439.3627.9519.9066.9519h6.6179c.4533 0 .8159-.3173.9065-.816.408-2.03971 2.1758-3.21824 4.5328-3.21824 3.2183 0 4.7595 1.67714 4.7595 4.48744v1.2692c0 .4986-.408.9066-.9066.9066h-6.6632c-4.7594 0-8.1137 1.9491-10.0175 4.8047-.2719.408-.5439.68-.9519.68-.4079 0-.6799-.272-.9519-.68-.6345-.9518-1.5864-1.8584-2.9463-2.4477-.3626-.136-.3626-.3626-.136-.5439 1.9945-1.5865 2.9464-3.4449 2.9464-5.80199 0-5.57534-3.8982-8.83896-10.5161-8.83896h-14.36901c-.498607 0-.906559.40795-.906559.90656v29.91649c0 .4986.407952.9066.906559.9066h14.82221c4.2609 0 8.2951-2.1758 10.1988-5.2581.272-.4079.544-.6799.9519-.6799.408 0 .7253.272.9519.6799 1.8585 3.3996 4.6235 5.53 9.0203 5.53 3.4449 0 5.8926-.9972 8.2497-3.7169.1813-.2266.4533-.1813.4986.0907.3626 1.4505 1.1332 2.493 2.3571 3.3089.3172.2267.6799.1813.9518-.0453l4.8048-3.5809c.8612-.6346 1.7678-.272 1.7678.6799v2.0851c0 .4986.408.9066.9066.9066h9.7002c7.1618 0 13.0091-3.7169 15.2755-9.7002.1813-.4533.5439-.68.9519-.68.4079 0 .7706.2267.9519.68 2.3117 6.3006 8.2043 10.1534 15.2755 10.1534z"
                                    fill="#c8001a"
                                ></path>
                            </svg>
                        </span>
                    </a>
                </Link>

                <div className="page-header__actions">
                    <ButtonGroup align="right">
                        <Button
                            tag="a"
                            linkAttrs={{
                                href: Route.SIGN_IN,
                            }}
                            text={common.lxButtonLoginText()}
                            onClick={onSignInClick}
                        />
                        <Button
                            linkAttrs={{ href: Route.SIGN_UP }}
                            tag="a"
                            variant="custom"
                            text={common.lxButtonSignupText()}
                            onClick={onSignUpClick}
                        />
                    </ButtonGroup>
                </div>
            </div>
        </header>
    );
};

export default PageHeader;
